import { useAuthentication } from "hooks/useAuthentication";
import { useUserRole } from "hooks/useUserRole";
import { TAX_ADMIN, TAX_COLLECTOR, TAX_PAYER, TAX_SUPER_ADMIN, TAX_SUPERVISOR } from "utils/roles";
import TaxAdminDashboardPage from "./TaxAdmin";
import TaxCollectorDashboardPage from "./TaxCollector";
import TaxPayerDashboardPage from "./TaxPayer";
import TaxSupervisorDashboardPage from "./TaxSupervisor";

export default function TaxDashboardPage() {
  const { user } = useAuthentication();
  const userRole = useUserRole();

  if (userRole === TAX_ADMIN || userRole === TAX_SUPER_ADMIN) {
    return <TaxAdminDashboardPage />;
  }
  if (userRole === TAX_COLLECTOR) {
    return <TaxCollectorDashboardPage />;
  }
  if (userRole === TAX_PAYER) {
    return <TaxPayerDashboardPage />;
  }
  if (userRole === TAX_SUPERVISOR) {
    return <TaxSupervisorDashboardPage />;
  }

  return null;
}